import React from "react";

/**
 * @typedef {Object} Property
 * @property {number} id
 * @property {string} image
 * @property {string} price
 * @property {string} type
 * @property {string} plan
 * @property {string} developer
 * @property {string} title
 * @property {string} location
 * @property {string} agent
 * @property {string} agentImg
 */

/** @type {Property[]} */

export const Projects = [
    {
        id: 1,
        image: "../Assets/1gallery1.webp",
        image1: "../Assets/1gallery2.webp",
        image2: "../Assets/1gallery3.webp",
        image3: "../Assets/1gallery4.webp",
        image4: "../Assets/1gallery5.webp",
        description: "Linar by Alef is an iconic 55-storey waterfront development located along the prestigious Al Mamzar coastline, perfectly positioned between Sharjah and Dubai. Developed by Alef Group, the project introduces a new standard of sea-facing luxury living. Featuring elegantly designed 1, 2, and 3-bedroom apartments with breathtaking Arabian Sea views, Linar offers an exceptional lifestyle for residents and investors alike. Alef Linar combining premium waterfront living, excellent connectivity, and strong investment potential, it delivers Dubai-adjacent luxury at a more accessible value.",
        type: "APARTMENT",
        plan: "Payment Plan: 80/20",
        masterPlanImage1: "../Assets/fp1.webp",
        masterPlanImage2: "../Assets/fp2.webp",
        paymentPlan: [
            { label: "Down Payment", value: "10%" },
            { label: "During Construction", value: "20%" },
            { label: "On Handover", value: "70%" },
        ],
        price: "AED 860K",
        developer: "Alef Group",
        title: "ALEF LINAR",
        url: "alef_linar",
        location: "Al Mamzar",
        locationDescription1: "Dubai International Airport",
        locationDescription2: "Deira",
        locationDescription3: "Dubai Islands",
        locationDescription4: "Downtown Dubai",
        agent: "Shiraz Khan",
        area: "806 Sq.ft. - 1930 Sq.ft.",
        bed: "1-3BR",
        pricePerSqft: "AED 860K - AED 2.3M",
        agentImg: "../Assets/agent_image.png",
        experience: "8+ Years of experience",
        project_name: "Linar by Alef",
    },
    {
        id: 2,
        image: "../Assets/2gallery1.webp",
        image1: "../Assets/2gallery2.webp",
        image2: "../Assets/2gallery3.webp",
        image3: "../Assets/2gallery4.webp",
        image4: "../Assets/2gallery5.webp",
        description: "Hayyan by Alef Group is a luxury community of townhouses, villas, and mansions set in Sharjah’s green heart. Inspired by nature, Alef Hayyan Sharjah blends elegant design with sustainable living, offering residents a serene lifestyle surrounded by lush landscapes. Strategically located near Emirates Road, Hayyan Sharjah provides excellent connectivity to Dubai and key destinations. Featuring the largest lagoon and community park in Sharjah, thousands of trees, edible gardens, vast playfields, and naturally lit interiors, Hayyan delivers a unique blend of luxury, nature, and modern convenience for a truly elevated living experience.",
        type: "Townhouses & Villas",
        plan: "Payment Plan: 5% Booking + 1% Monthly For 90 months",
        masterPlanImage1: "../Assets/m2.webp",
        masterPlanImage2: "../Assets/fp2.webp",
        paymentPlan: [
            { label: "Book By Paying Just 5% Only", value: "" },
            { label: "Pay 1% Monthly For 90 months ", value: "" },
        ],
        price: "AED 2.91 M",
        developer: "Alef Group",
        title: "Alef Hayyan Sharjah",
        url: "alef_hayyan_sharjah",
        location: "Sharjah",
        locationDescription1: "SHARJAH MOSQUE",
        locationDescription2: "DUBAI INTERNATIONAL AIRPORT",
        locationDescription3: "SHARJAH NATIONAL PARK",
        locationDescription4: "SHARJAH UNIVERSITY CITY",
        locationDescription5: "SHARJAH INTERNATIONAL AIRPORT",
        locationDescription6: "SHARJAH MUSEUM OF ISLAMIC CIVILIZATION",
        locationDescription7: "AL MAJAZ",
        locationDescription8: "SHARJAH INDUSTRIAL AREA",
        agent: "Shiraz Khan",
        area: "2894.55 Sq.ft. - 5456.81 Sq.ft.",
        bed: "4-6BR",
        pricePerSqft: "AED 2.91M - AED 8.11M",
        agentImg: "../Assets/agent_image.png",
        experience: "12+ Years of experience",
        project_name: "Alef Hayyan Sharjah",
    },
    {
        id: 3,
        image: "../Assets/3gallery1.jpg",
        image1: "../Assets/3gallery2.jpg",
        image2: "../Assets/3gallery3.jpg",
        image3: "../Assets/3gallery4.jpg",
        image4: "../Assets/3gallery5.jpg",
        description: "Al Mamsha Sharjah by Alef is a state-of-the-art, car-free, mixed-use development offering luxurious studios to 3-bedroom apartments in New Sharjah. Strategically located off Sheikh Mohammed Bin Zayed Road, Alef Al Mamsha provides seamless connectivity and a vibrant lifestyle. Residents enjoy walkable spaces, dynamic retail and entertainment zones, modern living, and iconic architecture. With active sports and family entertainment areas, Alef Al Mamsha Apartments redefines urban living in a lively, integrated community environment.",
        type: "APARTMENT",
        plan: "Payment Plan : 10/90",
        masterPlanImage1: "../Assets/m3.webp",
        masterPlanImage2: "../Assets/fp2.webp",
        paymentPlan: [
            { label: "Book By Paying Just 10% Only", value: "" },
        ],
        price: "AED 729 K",
        developer: "Alef Group",
        title: "Alef Al Mamsha",
        url: "alef_al_mamsha_sharjah",
        location: "University Road, Sharjah",
        locationDescription1: "University City of Sharja",
        locationDescription2: "Schools’ Complex",
        locationDescription3: "06 Mall",
        locationDescription4: "Sheikh Mohammad Bin Zayed Road",
        locationDescription5: "Sharjah International Airport",
        locationDescription6: "Dubai International Airport",
        area: "608 Sq.ft. - 2187 Sq.ft.",
        bed: "1-3BR",
        pricePerSqft: "AED 729K - On Request",
        agent: "Nova Capital",
        agentImg: "../Assets/agent_image.png",
        experience: "12+ Years of experience",
        project_name: "Alef Al Mamsha Sharjah",
    },
    {
        id: 4,
        image: "../Assets/4gallery1.webp",
        image1: "../Assets/4gallery2.webp",
        image2: "../Assets/4gallery3.webp",
        image3: "../Assets/4gallery4.webp",
        image4: "../Assets/4gallery5.webp",
        description: "Olfah at Sharjah by Alef Group is a sustainable, fully walkable, and car-free residential community offering elegant 1, 2, and 3-bedroom apartments across 12 architecturally designed buildings. Surrounded by 26,000 sqm of green spaces, Alef Olfah Sharjah blends urban sophistication with nature. Residents enjoy premium interiors, floor-to-ceiling windows, and expansive balconies with serene views. Located in Muweilah, near University City and Sharjah Mosque, Olfah Alef features amenities like swimming pools, outdoor gyms, woodland walks, and children’s play zones—creating a vibrant, inclusive community that redefines modern, eco-conscious living in Sharjah.",
        type: "APARTMENTS",
        plan: "Payment Plan: 30/70",
        masterPlanImage1: "../Assets/m4.jpg",
        masterPlanImage2: "../Assets/fp2.webp",
        paymentPlan: [
            // { label: "On Construction", value: "80%" },
            // { label: "On Handover", value: "20%" }
        ],
        price: "AED 850 K",
        developer: "Alef Group",
        title: "Alef Olfah",
        url: "alef_olfah_sharjah",
        location: "Sharjah",
        locationDescription1: "Sharjah Airport",
        locationDescription2: "Dubai Airport",
        locationDescription3: "University City",
        locationDescription4: "Dubai Downtown",
        area: "556 Sq.ft. - 1,633  Sq.ft.",
        bed: "1-3BR",
        pricePerSqft: "AED 850K - AED 1.8 M",
        agent: "Nova Capital",
        agentImg: "../Assets/agent_image.png",
        experience: "12+ Years of experience",
        project_name: "Alef Olfah Sharjah",
    }
]

